import React from 'react';
import colorConfigs from '../configs/colorConfigs';

const RentalJumper = () => {
  return (
    <div style={{
      backgroundColor: colorConfigs.jumper.bg,
      padding: "20px",
      color: "white",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      inset: 0,
      zIndex: 100001
    }}
    >
      <span style={{
        fontSize: "3rem"
      }}>
        RD Rental
      </span>
    </div>
  );
};

export default RentalJumper;
